import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  userData: null,
  loading: false,
  error: "",
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    SET_USER: (s, user) => (s.userData = user),
    LOADING: (s) => Object.assign(s, initState(), { loading: true }),
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: (s) => (s.loading = false),
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    async getDashboard({ commit }) {
      commit("LOADING");

      try {
        const dashboard = (await this.$api.get(`v1/cms/dashboard`))?.data?.data;
        if (dashboard) return dashboard;
        throw new Error();
      } catch (e) {
        errorHandler("Lấy dữ liệu trang chủ thất bại.");
      } finally {
        commit("LOADED");
      }
    },
  },
};
